import { Skeleton } from '@nextui-org/react-latest'

type Props = {
  count: number
}

const Loader = ({ count }: Props) => {
  return (
    <div className="flex flex-col w-full gap-3">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} className="h-8 rounded w-full" />
      ))}
    </div>
  )
}

export default Loader
